function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Website Analytics › conversion / interaction detail.
 * Replaces the legacy /Activity/Detail/{type}/{name}/{range} page in the dashboard's style:
 * header (name, type, window), KPI ribbon, the by-period rows as a column chart + table,
 * and the key values recorded on the event inline (the legacy KeyValues page stays
 * reachable for its column filters). Data: /metrics/detail/{type}/{name}/{range}
 * ({activity.items[{title,type,total,users,sessions,value,date}], activityMetrics, startDate, endDate})
 * and /metrics/keyvalues/{type}/{name}/{start}/{end} ({result[{keyName,keyValue,name}]}).
 */
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Pending } from "../../components/analytics-kit";
import ChartBoundary from "../market-intelligence/chart-boundary";
import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis, ChartValueAxisItem, ChartTooltip } from "@progress/kendo-react-charts";
import { num, usd, rangeLabelFor, RANGES } from "../sales/territory-common";
import ServiceFactory from "../../service";
import Auth from "../../functions/authenticate";
import { safe } from "./data";
import { exportCsv } from "./drilldowns";
import { fmtD } from "./header";
class ActivityDetail extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      ready: false,
      detail: undefined,
      kv: undefined
    });
  }
  async componentDidMount() {
    if (Auth.isAuthenticated() || (await Auth.attachOrSignIn())) this.setState({
      ready: true
    }, () => this.load());
  }
  componentDidUpdate(p) {
    const a = p.params || {},
      b = this.props.params || {};
    if (a.type !== b.type || a.name !== b.name || a.range !== b.range) this.load();
  }
  async load() {
    const {
      type,
      name,
      range
    } = this.props.params;
    this.setState({
      detail: undefined,
      kv: undefined
    });
    const S = ServiceFactory.getType(`/metrics/detail/${type}/${name}/${range}`);
    const r = await safe(new S().paginate({
      baseUrl: "",
      rawUrl: "",
      page: 1,
      pageSize: 200
    }).getAsync());
    const d = r && r.items ? r.items : r;
    const detail = d && d.activity ? d : null;
    this.setState({
      detail
    });
    if (!detail) {
      this.setState({
        kv: null
      });
      return;
    }
    const ymd = v => String(v || "").slice(0, 10);
    const K = ServiceFactory.getType(`/metrics/keyvalues/${type}/${name}/${ymd(detail.startDate)}/${ymd(detail.endDate)}`);
    const k = await safe(new K().getAsync());
    this.setState({
      kv: k && Array.isArray(k.result) ? k.result : Array.isArray(k) ? k : []
    });
  }
  render() {
    const {
      type,
      name,
      range
    } = this.props.params;
    const {
      ready,
      detail,
      kv
    } = this.state;
    if (!ready) return null;
    const isConv = !/engage|interact/i.test(type || "");
    const label = isConv ? "Conversion" : "Interaction";
    const displayName = String(name || "").replace(/@/g, " ");
    const m = detail && detail.activityMetrics || {};
    const rows = detail && detail.activity ? detail.activity.items || detail.activity || [] : [];
    const win = detail && detail.startDate ? `${fmtD(detail.startDate)} – ${fmtD(detail.endDate)}` : "";
    const ymd = v => String(v || "").slice(0, 10);
    // Key values: one row per (key, value) with a count.
    const kvRows = (() => {
      const acc = {};
      (kv || []).forEach(r => {
        const k = `${r.keyName || r.KeyName || ""} ${r.keyValue || r.KeyValue || ""}`;
        const a = acc[k] || (acc[k] = {
          key: r.keyName || r.KeyName || "",
          value: r.keyValue || r.KeyValue || "",
          count: 0
        });
        a.count += 1;
      });
      return Object.values(acc).sort((a, b) => b.count - a.count);
    })();
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view"
    }, /*#__PURE__*/React.createElement("header", {
      className: "wa-hdr"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "wa-crumbs"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/Activity"
    }, "Website Analytics"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: "/Activity/acquisition"
    }, "Acquisition"), " \xB7 ", label), /*#__PURE__*/React.createElement("h1", null, displayName, " ", /*#__PURE__*/React.createElement("span", {
      className: "wa-chip"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, label))), /*#__PURE__*/React.createElement("div", {
      className: "sub"
    }, [rangeLabelFor(range, RANGES), win].filter(Boolean).join(" · "))), /*#__PURE__*/React.createElement("a", {
      className: "wa-chip",
      href: "#",
      style: {
        marginLeft: "auto"
      },
      onClick: e => {
        e.preventDefault();
        exportCsv(`/metrics/detail/export/${type}/${name}/${range}`, `${displayName}-${range}.csv`);
      }
    }, "Export CSV")), detail === undefined ? /*#__PURE__*/React.createElement("div", {
      className: "wa-ribbon"
    }, /*#__PURE__*/React.createElement(Pending, {
      h: 90
    })) : !detail ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No activity found for this ", label.toLowerCase(), " in this range.") : /*#__PURE__*/React.createElement("div", {
      className: "wa-ribbon four"
    }, [["Total", num(m.total)], ["Users", num(m.users)], ["Sessions", num(m.sessions)], ["Value", Number(m.value) > 0 ? usd(m.value) : "—"]].map(([l, v]) => /*#__PURE__*/React.createElement("div", {
      className: "wa-kpi",
      key: l
    }, /*#__PURE__*/React.createElement("div", {
      className: "l"
    }, l), /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, v)))), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement("section", {
      className: "wa-card c6"
    }, /*#__PURE__*/React.createElement("h2", null, "By period", /*#__PURE__*/React.createElement("span", {
      className: "hint"
    }, rows.length > 1 ? "total per period" : "this range")), detail === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "Nothing in this range.") : rows.length > 1 ? /*#__PURE__*/React.createElement(ChartBoundary, null, /*#__PURE__*/React.createElement(Chart, {
      transitions: false,
      style: {
        height: 240
      }
    }, /*#__PURE__*/React.createElement(ChartCategoryAxis, null, /*#__PURE__*/React.createElement(ChartCategoryAxisItem, {
      categories: rows.map(r => r.date),
      labels: {
        font: "11px Proxima Nova, sans-serif",
        color: "#666"
      },
      majorGridLines: {
        visible: false
      }
    })), /*#__PURE__*/React.createElement(ChartValueAxis, null, /*#__PURE__*/React.createElement(ChartValueAxisItem, {
      labels: {
        format: "{0:n0}",
        font: "11px Proxima Nova, sans-serif",
        color: "#888"
      },
      majorGridLines: {
        color: "#eceff3"
      },
      line: {
        visible: false
      },
      min: 0
    })), /*#__PURE__*/React.createElement(ChartSeries, null, /*#__PURE__*/React.createElement(ChartSeriesItem, {
      type: "column",
      data: rows.map(r => Number(r.total) || 0),
      name: label + "s",
      color: isConv ? "#ff6358" : "#78d237",
      gap: 1.4,
      labels: {
        visible: true,
        position: "top",
        font: "11px Proxima Nova, sans-serif",
        content: e => num(e.value)
      }
    })), /*#__PURE__*/React.createElement(ChartTooltip, {
      render: e => e && e.point ? `${e.point.category}: ${num(e.point.value)}` : ""
    }))) : null, rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Period"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Total"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Users"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sessions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Value"))), /*#__PURE__*/React.createElement("tbody", null, rows.map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, r.date)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.total)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.users)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.sessions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, Number(r.value) > 0 ? usd(r.value) : "—")))))) : null), /*#__PURE__*/React.createElement("section", {
      className: "wa-card c6"
    }, /*#__PURE__*/React.createElement("h2", null, "Key values", /*#__PURE__*/React.createElement("span", {
      className: "hint"
    }, "recorded on the event"), detail ? /*#__PURE__*/React.createElement(Link, {
      className: "more",
      to: `/Activity/KeyValues/${type}/${name}/${ymd(detail.startDate)}/${ymd(detail.endDate)}`
    }, "Filter view \u2192") : null), kv === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !kvRows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No key values were sent with this ", label.toLowerCase(), " in this range. The tracker records them when the event carries key/value pairs.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Key"), /*#__PURE__*/React.createElement("th", null, "Value"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Count"))), /*#__PURE__*/React.createElement("tbody", null, kvRows.slice(0, 50).map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, r.key)), /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, r.value), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.count))))))))));
  }
}
export default withRouter(ActivityDetail);